<template>
    <div
        style="
background: #F5F5F5;"
    >
        <top></top>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
            <div class="my-title">
                招聘信息
            </div>
            <div
                class="recrutment_wp"
                v-for="(item, index) in orderData"
                :key="index"
            >
                <div class="recrutment_list">
                    <div class="recrutment_list_right">
                        <div class="right1">
                            <span class="span1">{{ item.job }}</span>
                            <span class="span2"
                                >工作地点:{{ item.address }}</span
                            >
                        </div>
                        <div class="right2">
                            <span class="span1"
                                >职位薪资:{{ item.salary }}</span
                            >
                            <span class="span2"
                                >学历:{{ item.edu }}|经验:{{ item.exp }}|类型:{{
                                    item.work_model_text
                                }}</span
                            >
                        </div>
                        <div class="right3">
                            <span>岗位职责：{{ item.duty }}</span>
                        </div>
                        <div class="right4">
                            <span>发布时间：{{ item.time }}</span>
                        </div>
                    </div>
                    <div class="recrutment_list_left">
                        <el-button type="primary" @click="recuriBnt(item.id)"
                            >查看详情</el-button
                        >
                    </div>
                </div>
            </div>
        </div>


        <!-- 分页 -->
        <div class="shopp_pagination">
            <el-button
                size="small"
                style="width: 80px;height: 40px;"
                @click="pervious"
                >上一页</el-button
            >
            <el-pagination
                ref="pageGroup"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="handleCurrentChange"
                background
                layout="pager"
                :total="total"
            >
            </el-pagination>
            <el-button
                style="width: 80px;height: 40px;"
                size="small"
                @click="next"
                >下一页</el-button
            >
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import { recruitIndex } from "@/api/index.js";
import { timestampToTime } from "@/util/util.js";
export default {
    data() {
        return {
            url: [{ name: "招聘信息", url: "/recrutment" }],
            geRecrutLists: [],
            currentPage: 1,
            pageSize: 4,
            total: 1,


        };
    },
    created() {
        this.getRecruitIndex();
    },
    methods: {
        //招聘信息
        getRecruitIndex() {
            recruitIndex({}).then(res => {
                console.log(res.data);
                res.data.lists.forEach(i=>{
                 i.time = timestampToTime(i.createtime * 1000)
                })
                this.geRecrutLists = res.data.lists;
                this.total = res.data.count;
            });
        },
        //上一页
        pervious() {
            this.$refs.pageGroup.prev();
        },
        //下一页
        next() {
            this.$refs.pageGroup.next();
        },
        handleCurrentChange(newNum) {
            this.currentPage = newNum;
        },
        recuriBnt(i) {
            this.geRecrutLists.forEach(item => {
                if (item.id === i) {
                    this.$router.push({ path: '/recruitmentDetail',query:{content:item.content} });

                }
            });
        }
    },
    components: {
        top,
        breadcrumb,
        bottom
    },
    computed: {
        orderData: function() {
            return this.geRecrutLists.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize
            );
        }
    }
};
</script>
<style lang="less" scoped>
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    line-height: 40px;
    font-weight: 400;
}
.recrutment_wp {
    width: 1200px;
    height: 189px;
    background: #ffffff;
    border: 1px solid #d8d8d8;
    display: flex;
    margin-bottom: 22px;
    .recrutment_list {
        display: flex;

        .recrutment_list_right {
            display: flex;
            flex-direction: column;
            padding-left: 28px;
            .right1 {
                padding-bottom: 18px;
                .span1 {
                    width: 112px;
                    height: 28px;
                    font-size: 28px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                    font-weight: 500;
                    color: #333333;
                    line-height: 42px;
                    padding-right: 22px;
                }
                .span2 {
                    width: 109px;
                    height: 16px;
                    font-size: 16px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                    font-weight: 500;
                    color: #999999;
                    line-height: 24px;
                }
            }
            .right2 {
                padding-bottom: 18px;
                .span1 {
                    width: 154px;
                    height: 22px;
                    font-size: 22px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                    font-weight: 500;
                    color: #ff6701;
                    line-height: 33px;
                }
                .span2 {
                    width: 373px;
                    height: 25px;
                    font-size: 18px;
                    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                    font-weight: 400;
                    color: #999999;
                    line-height: 27px;
                }
            }
            .right3 {
                width: 778px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                padding-bottom: 18px;
                span {
                    width: 778px;
                    height: 20px;
                    font-size: 20px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                    font-weight: 500;
                    color: #666666;
                    line-height: 30px;
                }
            }
            .right4 {
                span {
                    width: 149px;
                    height: 17px;
                    font-size: 14px;
                    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                    font-weight: 400;
                    color: #999999;
                    line-height: 21px;
                }
            }
        }
        .recrutment_list_left {
            display: flex;
            justify-content: end;
            align-items: center;
            text-align: ens;
            margin-left: 178px;
        }
    }
}
.el-pagination {
    display: flex;
    justify-content: center;
}
.shopp_pagination {
    display: flex;
    margin-bottom: 20px;
    justify-content: center;
}
/deep/ .el-pager li {
    width: 40px !important;
    height: 38px !important;
    line-height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index/recruitment.vue